import { useState, useEffect, useRef } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

function useGetGatewayLinks(enabled = true) {
  const [gateways, setGateways] = useState([]);
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const firstLoad = useRef(true);

  useEffect(() => {
    if (!enabled) return;

    let isMounted = true;

    const fetchLinks = () => {
      if (firstLoad.current) setIsLoading(true);
      authFetch(`${API_URL}gateways/links`)
        .then(res => {
          if (!res.ok) throw new Error('Error al obtener enlaces de gateways');
          return res.json();
        })
        .then(data => {
          if (!isMounted) return;
          setGateways(data.gateways ?? []);
          setLinks(data.links ?? []);
          setError(null);
          setIsLoading(false);
          firstLoad.current = false;
        })
        .catch(err => {
          if (!isMounted) return;
          console.error('Error al obtener enlaces de gateways:', err);
          if (firstLoad.current) {
            setError(err);
            setIsLoading(false);
          }
        });
    };

    fetchLinks();
    const interval = setInterval(fetchLinks, 120000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [enabled]);

  return { gateways, links, isLoading, error };
}

export default useGetGatewayLinks;
